<script>
  export let content = '';
  content = toItalic(content);
</script>

<div class="container">
  <div class="icon-wrapper">
    <svg width="46" height="35" viewBox="0 0 46 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_545_46"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="46"
        height="35"
      >
        <path
          d="M9.17251 5.75C-0.0674896 13.29 -1.90749 23.17 1.78251 27.7C5.36251 32.09 9.41251 31.87 13.6725 31.66C17.0425 31.49 20.5325 31.32 24.0425 33.41C33.6725 39.16 54.8325 25.45 40.4725 7.85C36.0225 2.4 30.2825 0 24.5025 0C19.0925 0 13.6425 2.1 9.17251 5.74"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_545_46)">
        <path d="M54.8438 0H-1.90625V39.16H54.8438V0Z" fill="url(#paint0_linear_545_46)" />
      </g>
      <path
        d="M32.6119 12.1517L28.2119 14.8017L27.9219 14.9517C28.2119 15.2617 28.5219 15.6717 28.6719 15.8917C28.8519 15.8117 29.1219 15.6917 29.2919 15.6017L31.8419 14.2817C32.0819 14.1617 32.3419 14.0217 32.6019 13.8817C33.5219 13.3817 34.5719 12.8117 35.6219 12.6817C36.1919 12.6117 36.7719 12.7017 37.0619 12.7617C37.1619 12.3617 37.2819 11.4117 36.3219 10.9417C35.3419 10.4517 33.9619 11.3117 32.9519 11.9317C32.8219 12.0117 32.7019 12.0817 32.5919 12.1517"
        fill="white"
      />
      <path
        d="M19.3954 20.4811C19.3054 20.5311 19.2054 20.5511 19.1054 20.5511C18.9454 20.5511 18.7854 20.4911 18.6954 20.3811C18.5554 20.2111 18.5454 19.8611 18.7454 19.6411C19.2954 19.0511 20.0754 18.6311 21.0654 18.3911C22.9254 17.9411 24.9554 18.1611 26.7754 19.0211C26.7754 19.0211 26.7754 19.0211 26.7954 19.0211C26.9754 19.1111 27.4154 19.3511 27.5254 19.6911C27.5754 19.8311 27.5554 19.9811 27.4854 20.1111C27.3854 20.2911 27.0754 20.4211 26.8354 20.3211C24.1154 19.1511 21.6154 19.2011 19.3954 20.4611M31.8554 22.0611C32.0954 21.9511 32.3354 21.8311 32.5654 21.7111C33.2554 21.3411 33.8054 21.0011 34.2954 20.6411L34.3754 20.5811C34.9154 20.1811 35.5754 19.6811 35.5854 19.0411C35.5854 19.0311 35.5854 19.0211 35.5854 19.0011C35.5854 18.6811 35.4354 18.3811 35.1854 18.1511C34.9054 17.9011 34.5254 17.7811 34.1654 17.8211C33.6454 17.8811 33.1354 18.1011 32.6454 18.3111L32.0454 18.5611C31.6454 18.7311 31.2454 18.8911 30.8454 19.0611C30.5854 19.1611 30.3154 19.2711 30.0554 19.3711L29.8754 19.4411C29.6854 19.5211 29.4854 19.6011 29.2754 19.6511C28.9754 19.7211 28.7154 19.6011 28.5854 19.3311C28.4754 19.1011 28.5054 18.8711 28.6554 18.6611C28.3154 17.7411 27.8354 16.9011 27.2454 16.1511C26.9254 15.7511 26.5654 15.3611 26.1654 15.0211C26.0354 14.9011 25.8954 14.7911 25.7554 14.6811L25.5754 14.5411C25.4354 14.4311 25.3054 14.2211 25.3154 14.0211C25.3154 13.8811 25.3954 13.7611 25.5054 13.6811C25.7954 13.4811 26.2054 13.6611 26.3854 13.7311C26.5554 13.8011 26.7754 13.9511 26.9054 14.0411L27.2454 13.8511C27.2454 13.8511 32.6254 10.7111 33.6654 10.1011C33.5154 9.84109 33.2254 9.64109 32.8454 9.56109C32.7154 9.53109 32.5654 9.5211 32.4154 9.5211C31.2754 9.5211 29.9054 10.3311 28.8054 10.9811L28.7154 11.0311C28.4854 11.1611 28.2754 11.2911 28.0654 11.4111C27.8554 11.5311 27.6354 11.6511 27.4254 11.7711C26.5254 12.2811 25.5954 12.8111 24.5554 13.1811C23.6154 13.5111 22.5954 13.6311 21.6854 13.7211L21.4954 13.7411C21.4954 13.7411 21.4154 13.7411 21.3754 13.7411C21.1154 13.7411 20.8154 13.7311 20.5954 13.5411C20.4854 13.4511 20.4354 13.3511 20.4254 13.2411C20.4254 13.0711 20.5354 12.9711 20.6254 12.8911L20.6754 12.8411C20.7754 12.7411 20.8754 12.6311 20.9654 12.5111C21.1254 12.3011 21.2754 12.0711 21.4154 11.7911C21.6654 11.3111 22.1654 10.1011 21.5954 9.14109C21.2254 8.52109 20.5154 8.12109 19.7854 8.12109C19.5654 8.12109 19.3454 8.16109 19.1254 8.24109C18.6754 8.40109 18.5354 8.80109 18.3154 9.41109C18.0254 10.2611 17.6254 11.4111 16.1254 12.8211L14.6154 14.2411C13.7954 15.0111 13.2654 16.0111 12.9954 17.2911C12.8254 18.0711 12.8454 18.7711 13.0354 19.4411C13.0854 19.6211 13.0654 19.8211 12.9654 19.9811L12.0854 21.5011C12.0254 21.6011 12.0354 21.7311 12.1154 21.8211C14.1854 24.2211 16.5154 25.6511 19.9054 26.6211C20.0354 26.6611 20.1654 26.6011 20.2254 26.4811L20.7654 25.3911C20.8954 25.1311 21.1654 24.9711 21.4354 24.9911C21.5354 24.9911 21.6654 25.0011 21.7454 24.9911C21.8154 24.9911 21.8754 24.9911 21.9454 24.9911C22.9554 24.9611 23.9454 24.8111 25.0554 24.5111C27.4854 23.8611 29.7054 23.0611 31.8554 22.0711"
        fill="white"
      />
      <path
        d="M36.2059 17.0809C36.7259 16.7309 37.0759 16.4009 37.3059 16.0109C37.4559 15.7609 37.5359 15.4909 37.5359 15.2409C37.5359 14.7909 37.3159 14.4409 36.9359 14.2509C36.9359 14.2509 36.9159 14.2509 36.9159 14.2409C36.4959 14.0409 35.9459 14.0109 35.4159 14.1609C34.7959 14.3309 34.1959 14.6409 33.6259 14.9409L33.2859 15.1209C31.8959 15.8409 30.6359 16.4909 29.3359 17.0509C29.5159 17.4009 29.6259 17.7409 29.6859 18.1009C30.7659 17.6109 31.8059 17.1409 32.9259 16.7309C33.6959 16.4509 34.3459 16.3609 34.9259 16.4609C35.5159 16.5609 35.9859 16.9109 36.2059 17.1109"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_545_46"
          x1="-9.85905"
          y1="21.1623"
          x2="35.471"
          y2="21.1623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4DB4AA" />
          <stop offset="1" stop-color="#B56F4E" />
        </linearGradient>
      </defs>
    </svg>
  </div>
  <div class="titulo">
    <h2><b>CAIS</b> NA PRÁTICA</h2>
  </div>
  <div class="box-texto">
    {@html content}
  </div>
</div>

<style>
  .container {
    --Principais-Roxo-azul: #8421e9;
    --transparentes-roxo-10: rgba(132, 33, 233, 0.1);
    --cor-primaria: #b62ca2;
    --cor-secundaria: #33cfb9;

    position: relative;
    margin-top: 16px;
    /*margin-bottom: 30px;*/
    padding-top: 3px;
  }

  .icon-wrapper {
    position: absolute;
    top: -5px;
    left: -32px;
    z-index: 10;
  }

  .icon-wrapper svg {
    width: 80px;
    filter: drop-shadow(0 0 3px #00000044);
    max-width: unset;
    height: auto;
  }

  .box-texto {
    width: 100%;
    height: auto;

    color: var(--VERDE);
    font-family: 'Inter';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px;

    border-radius: 0 35px 35px 35px;
    padding: 25px 30px 25px 29px;
    white-space: pre-wrap;
    word-break: break-word;

    border: 2px solid var(--MARROM);
    background-color: var(--MARROM_CLARO);

    background-origin: border-box;
    background-clip: padding-box, border-box;
  }
  .titulo {
    width: fit-content;
    padding: 6px 15px 6px 60px;
    border-radius: 0 30px 30px 0;
    background: linear-gradient(to right, var(--VERDE_CLARO), var(--MARROM));
  }

  .titulo h2 {
    color: var(--Principais-Branco, #fff);
    font-family: var(--FONT_ARCHI);
    font-size: 24px;
    /* font-style: italic; */
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 0em;
  }

  @media (max-width: 800px) {
    .icon-wrapper {
      top: -5px;
      transform: translateY(0px);
      left: 10px;
    }

    .icon-wrapper svg {
      width: 60px;
      height: unset;
      filter: drop-shadow(0 0 3px #00000044);
    }
    .titulo {
      padding: 7px 15px 7px 50px;
      border-radius: 28px 8.7px 8.7px 0px;
      top: 18px;
      position: relative;
    }
    .box-texto {
      padding: 20px 20px 15px 20px;
      margin-top: 18px;
    }
  }
</style>
